export default {
  context: "",
  botDisplayName: "Hjälprobot",
  introMessageText: "Vi använder AI-funktionalitet.<br><a aria-label='Länk till användarvillkor, öppnas i ny flik' target='_blank' href='https://www.ica.se/kundservice/villkor-for-icas-hjalprobot/'>Läs om användarvillkor.</a><br><br>Tänk på att inte skriva känsliga uppgifter i chatten.",
  introMessageLinkUrl: "",
  introMessageLinkText: "",
  introMessageLinkAriaLabel: "",
  greeting: {
    userUrl: "",
    messages: [],
  },
  launchIconImageURL: "https://assets.icanet.se/image/upload/v1623865838/digitalassistent/icons/chatbot--white.svg",
  closeChatImageURL: "https://assets.icanet.se/image/upload/v1592490640/digitalassistent/icons/ica-close.svg",
  minimizeChatImageURL: "https://assets.icanet.se/image/upload/v1592490640/digitalassistent/icons/ica-angle-down.svg",
  calloutMessage: "Fråga mig!",
  sendMessageImageURL: "https://assets.icanet.se/image/upload/digitalassistent/icons/send.svg",
  uploadImageURL: "",
  botAvatarImageURL: 'https://assets.icanet.se/image/upload/v1623865838/digitalassistent/icons/chatbot--red.svg',
  agentAvatarImageURL: 'https://assets.icanet.se/image/upload/v1605706331/digitalassistent/icons/twc-agent.svg',
  visibleBotAvatar: false,
  visibleLaunchIcon: false,
  enabledCallout: true,
  additionalData: {}, // Sent to the backend with each message via the 'context' request field
  livechatProvider: "mitel" as const,
  triggerLoginOnChatOpen: true
}